var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNfdPlatformItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 38,
    viewBox: "0 0 35 38",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1506_26017",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 38
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0547 1.722C19.2424 0.0718342 15.7576 0.0718345 12.9453 1.722L4.94528 6.41615C2.19155 8.03195 0.5 10.9857 0.5 14.1785V23.8206C0.5 27.0134 2.19155 29.9672 4.94528 31.583L12.9453 36.2771C15.7576 37.9273 19.2424 37.9273 22.0547 36.2771L30.0547 31.583C32.8085 29.9672 34.5 27.0134 34.5 23.8206V14.1785C34.5 10.9857 32.8084 8.03195 30.0547 6.41615L22.0547 1.722ZM17.5001 27.0712C22.1486 25.5543 25.0646 18.637 25.4143 15.0496C23.9721 12.3806 19.9674 10.9279 17.5001 10.9279C15.0328 10.9279 11.0281 12.3806 9.5859 15.0496C9.9356 18.637 12.8517 25.5543 17.5001 27.0712Z",
    fill: "url(#paint0_linear_1506_26017)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1506_26017)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -2.53125,
    y: -0.539062,
    width: 37.3602,
    height: 38.5389,
    fill: "url(#paint1_linear_1506_26017)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0378 16.6233C30.8478 28.9615 21.6365 28.7873 17.4733 27.0585L10.1937 13.7572L4.6875 16.6233V30.4082L13.8615 37.8722L39.8724 42.2824C40.0066 28.5885 39.2277 4.28519 35.0378 16.6233Z",
    fill: "url(#paint2_linear_1506_26017)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4162 15.0461C22.8205 3.06839 10.394 2.80187 4.31435 4.07923C-1.55332 4.38186 -3.9182 13.1768 -4.36719 17.5364L-1.56105 33.4889L9.63302 34.3522C4.23135 25.8679 7.34193 17.8088 9.59263 15.0461L25.4162 15.0461Z",
    fill: "url(#paint3_linear_1506_26017)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1506_26017",
    x1: 17.5,
    y1: 0.484375,
    x2: 17.5,
    y2: 37.5148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7551FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7872F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1506_26017",
    x1: 26.3484,
    y1: 4.09443,
    x2: 16.6836,
    y2: 27.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6B0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A08AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1506_26017",
    x1: 27.0203,
    y1: 35.1441,
    x2: 6.83061,
    y2: 26.9749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6B0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A08AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1506_26017",
    x1: -2.85508,
    y1: 31.0483,
    x2: 23.3243,
    y2: 10.3072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6B0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A08AFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNfdPlatformItem);
export default __webpack_public_path__ + "static/media/NfdPlatformItem.8902f3503b2f448a9716ea291ce18de3.svg";
export { ForwardRef as ReactComponent };